/**
 * In-app paths under `/operation/monitor/**` (executions, pipeline logs).
 */
export function buildMonitorExecutionFinishUrl(
  realm: string,
  pipelineName: string,
  monitorEnvironment: string
): string {
  const query = new URLSearchParams({
    time: '5 Minutes',
    pipelineName
  });
  return `/${encodeURIComponent(realm)}/operation/monitor/${encodeURIComponent(
    monitorEnvironment
  )}/execution-finish?${query.toString()}`;
}

export function buildPipelineLogsUrl(
  realm: string,
  environment: string,
  pipelineName: string,
  timeFilter: string
): string {
  const query = new URLSearchParams({
    pipelineName,
    time: timeFilter
  });
  const basePath = `/${encodeURIComponent(realm)}/operation/monitor/${encodeURIComponent(environment)}/pipeline-logs`;
  return `${basePath}?${query.toString()}`;
}
